/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { defineMessages } from 'react-intl';

export default defineMessages({
  fulfillmentAddressDetail: {
    id: 'OrderView.FulfillmentCard.fulfillmentAddressDetail',
    defaultMessage: 'Buyer Info'
  },
  sellerFacilityName: {
    id: 'OrderView.FulfillmentCard.sellerFacilityDetail',
    defaultMessage: 'Seller Info'
  },
  fulfillmentAddressDetailPhone: {
    id: 'OrderView.FulfillmentCard.fulfillmentAddressDetail.phone',
    defaultMessage: 'Phone: {phoneNumber}'
  },
  fulfillmentMethodDetail: {
    id: 'OrderView.FulfillmentCard.fulfillmentMethodDetail',
    defaultMessage: 'Delivery Method'
  },
  shippingTrackingNumber: {
    id: 'OrderView.FulfillmentCard.shippingTrackingNumber',
    defaultMessage: 'Track Shipment'
  },
  shippingShipDate: {
    id: 'OrderView.FulfillmentCard.shippingShipDate',
    defaultMessage: 'Ship Date: {date} at {time}'
  },
  shippingShipperTypeLabel: {
    id: 'OrderView.FulfillmentCard.shippingShipperTypeLabel',
    defaultMessage: 'Shipper Type: {type}'
  },
  shippingShipperTypeValue: {
    id: 'OrderView.FulfillmentCard.shippingShipperTypeValue',
    defaultMessage: '{type}',
    description:
      'Use this to translate constants like UPS_GROUND into something friendly, e.g., {type, select, UPS_GROUND {UPS Ground} other {Not specified} }'
  },
  shippingTrackingUrl: {
    id: 'OrderView.FulfillmentCard.shippingTrackingUrl',
    defaultMessage: 'Tracking URL: {url}'
  },
  fulfillmentPaymentDistributionDetail: {
    id: 'OrderView.FulfillmentCard.fulfillmentPaymentDistributionDetail',
    defaultMessage: 'Payment Distribution'
  },
  fulfillmentPaymentDistributionDetailHelpText: {
    id:
      'OrderView.FulfillmentCard.fulfillmentPaymentDistributionDetailHelpText',
    defaultMessage:
      'The values in this section are estimated for display and have not been rounded.'
  },
  fulfillmentTotalDetail: {
    id: 'OrderView.FulfillmentCard.fulfillmentTotalDetail',
    defaultMessage: 'Total'
  },
  merchandiseTotal: {
    id: 'OrderView.FulfillmentCard.fulfillmentMerchandiseTotal',
    defaultMessage: 'Merchandise Total'
  },
  fulfillmentTotal: {
    id: 'OrderView.FulfillmentCard.fulfillmentChargeTotal',
    defaultMessage: 'Delivery Charges'
  },
  taxTotal: {
    id: 'OrderView.FulfillmentCard.fulfillmentTaxTotal',
    defaultMessage: 'Taxes'
  },
  grandTotal: {
    id: 'OrderView.FulfillmentCard.fulfillmentGrandTotal',
    defaultMessage: 'Grand Total'
  },
  referenceNumber: {
    id: 'OrderView.FulfillmentCard.referenceNumber',
    defaultMessage: 'Reference Number'
  }
});
